let observer = undefined
let entriesData = new Map()

export function createObserver(headerHeight) {
    if (observer)
        observer.disconnect()

    const viewportWidth = window.innerWidth
    observer = new IntersectionObserver((entries) => {
        requestAnimationFrame(() => {
            for (let entry of entries) {
                const targetData = entriesData.get(entry.target)
                const target = entry.target.children?.[0]
                if (target) {
                    let ratio = entry.intersectionRatio
                    if (entry.intersectionRect.top > headerHeight) {
                        ratio += .5

                        if (ratio > 1) {
                            ratio = 1
                        }
                    } else {
                        ratio = 1
                    }

                    const minVisibleRatio = targetData?.minVisibleScale || (viewportWidth > 767 ? 0.75 : 0.8)
                    const visibleRatio = Math.max(minVisibleRatio, Math.round(ratio * 10000) / 10000)

                    const scale = targetData?.scaleType || 'scale'

                    if (target.style.transform !== `${scale}(${visibleRatio}) translateZ(0)`) {
                        target.style.transform = `${scale}(${visibleRatio}) translateZ(0)`
                    }

                    if (entry.target.style.opacity !== '1') {
                        entry.target.style.opacity = 1
                    }
                }
            }
        })
    }, {
        root: null,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
        threshold: Array.from({length: 101}, (_, i) => i / 100), // 0, 0.01, ..., 1
    })

    const targetElements = document.getElementsByClassName('OnScrollAnimateScale')
    const children = new Map()
    for (let targetElement of targetElements) {
        const minVisibleScale = targetElement.getAttribute('data-min-visible-scale')
        entriesData.set(targetElement, {
            minVisibleScale: minVisibleScale ? parseFloat(minVisibleScale) : undefined,
            scaleType: targetElement.getAttribute('data-scale-type'),
        })

        const targetChildren = targetElement.children
        const targetChildrenLength = targetChildren.length
        if (targetChildrenLength > 1) {
            const wrapper = document.createElement('div')
            wrapper.style.transformOrigin = 'center top'

            for (let i = 0; i < targetChildrenLength; ++i) {
                children.set(i, targetChildren[i])
            }

            targetChildren[0].parentNode.insertBefore(wrapper, targetChildren[0])
            for (let i = 0; i < children.size; ++i) {
                wrapper.appendChild(children.get(i))
            }
            children.clear()
        } else if (targetChildrenLength === 1) {
            targetChildren[0].style.transformOrigin = 'center top'
        }

        setTimeout(() => {
            observer.observe(targetElement)
        }, 50)
    }
}
